module.exports = __webpack_public_path__ + "img/flow.de.559ab8b2.png";